export type ErrorCode =
  | 'PARAM_VALIDATION'
  | 'SESSION_EXPIRED'
  | 'SESSION_INVALID'
  | 'PERMISSION_DENIED'
  | 'NOT_FOUND'
  | 'CONFLICT'
  | 'EXPORT_EXPIRED'
  | 'EXPORT_NOT_READY'
  | 'SEMI_JOIN_TOO_BROAD'
  | 'RATE_LIMIT'
  | 'API_AUTH'
  | 'API_ERROR'
  | 'TIMEOUT'
  | 'DATA_SCOPE_INVALID'
  | 'INSUFFICIENT_GRANT_LEVEL'
  | 'TENANT_REPORT_DISABLED'
  | 'UNKNOWN';

export class AuthRefreshFailedError extends Error {
  constructor() {
    super('Token refresh failed — session ended');
    this.name = 'AuthRefreshFailedError';
  }
}

export interface ErrorEnvelope {
  error: {
    code: ErrorCode;
    message: string;
    details?: Record<string, unknown>;
    request_id?: string;
  };
}

export class ApiError extends Error {
  readonly code: ErrorCode;
  readonly details: Record<string, unknown> | undefined;
  readonly requestId: string | undefined;
  readonly httpStatus: number;

  constructor(
    message: string,
    code: ErrorCode,
    httpStatus: number,
    details?: Record<string, unknown>,
    requestId?: string,
  ) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.httpStatus = httpStatus;
    this.details = details;
    this.requestId = requestId;
  }

  get isUnauthorized(): boolean {
    return this.code === 'SESSION_EXPIRED' || this.code === 'SESSION_INVALID';
  }

  get isNotFound(): boolean {
    return this.code === 'NOT_FOUND';
  }

  get isRateLimit(): boolean {
    return this.code === 'RATE_LIMIT';
  }

  static fromEnvelope(envelope: ErrorEnvelope, httpStatus: number): ApiError {
    return new ApiError(
      envelope.error.message,
      envelope.error.code,
      httpStatus,
      envelope.error.details,
      envelope.error.request_id,
    );
  }
}
